import { trackSelfDescribingEvent } from "@snowplow/browser-tracker";
import { redirect } from "react-router-dom";

const ORDERED_DEFAULT_ONBOARDING_ROUTES = [
  "age",
  "company",
  "gender",
  "topics",
  "learn",
  "learn-faster",
  "productivity",
  "learning",
  "tailored",
  "opportunities",
  "potential",
  "complex",
  "progress",
  "youtube-or-podcasts",
  "youtube-covered",
];

export default async function navigateToNextOnboardingPageAction({
  request,
}: {
  request: Request;
}) {
  const formData = await request.formData();

  trackFormDataWithSnowplow({ formData, url: request.url });

  const next = getNext(request.url);

  const currentPage = request.url.split("/").pop()?.split("?")[0];

  if (!next) return redirect("/sign-up/password");

  const nextPathname = getNextPathName({ next, url: request.url });

  if (currentPage === "success") {
    const hash = formData.get("success") as string;

    return redirect(`${nextPathname}#${hash}`);
  } else {
    return redirect(nextPathname);
  }
}

function getCurrentIndex(url: string): number | undefined {
  const pathname = new URL(url).pathname;
  const current = pathname.split("/").pop();

  if (!current) return;

  const orderedOnboardingRoutes = getOrderedOnboardingRoutes();

  return orderedOnboardingRoutes.indexOf(current);
}

function getNext(url: string): string | undefined {
  const orderedOnboardingRoutes = getOrderedOnboardingRoutes();
  const currentIndex = getCurrentIndex(url);

  if (currentIndex === undefined) return;

  return orderedOnboardingRoutes[currentIndex + 1];
}

function getNextPathName({ next, url }: { next: string; url: string }): string {
  const currentPathname = new URL(url).pathname;
  const paths = currentPathname.split("/");
  const basePathname = paths.slice(0, -1).join("/");
  const nextPathname = basePathname + "/" + next;
  return nextPathname;
}

function getOrderedOnboardingRoutes(): string[] {
  return ORDERED_DEFAULT_ONBOARDING_ROUTES;
}

function trackFormDataWithSnowplow({
  formData,
  url,
}: {
  formData: FormData;
  url: string;
}) {
  const entries = Array.from(formData.entries());
  const keys = [...new Set(entries.map(([key]) => key))];

  const onboardingRoutes = getOrderedOnboardingRoutes();
  const steps_total = onboardingRoutes.length;
  const currentIndex = getCurrentIndex(url);
  const step = currentIndex === undefined ? undefined : currentIndex + 1;

  for (const key of keys) {
    const data = {
      answers: formData.getAll(key),
      question: key,
      step,
      steps_total,
      url,
    };

    trackSelfDescribingEvent({
      event: {
        data,
        schema: "iglu:com.asanarebel/onboarding_event/jsonschema/1-0-0",
      },
    });
  }
}
